import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BonusroomPage } from './bonusroom';

@NgModule({
  declarations: [
    BonusroomPage,
  ],
  imports: [
    IonicPageModule.forChild(BonusroomPage),
  ],
})
export class BonusroomPageModule {}



// WEBPACK FOOTER //
// ./src/pages/bonusroom/bonusroom.module.ts